/* This is needed because the modal should be a div even though it's clickable */
/* eslint react/no-did-mount-set-state:0 */

import React from 'react';
import i18n from 'app/common/lib/i18n';
import InlineStyle from 'app/common/react/components/InlineStyle';
import PropTypes from 'prop-types';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { Icon } from 'gestalt';

const ModalCSS = `
.AccountSwitcherModal {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
`;

const modalStyles = {
  mask: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    opacity: 1,
    position: 'fixed',
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    zIndex: 1000,
  },
  scroller: {
    WebkitOverflowScrolling: 'touch',
    overflowY: 'scroll',
    bottom: '0px',
    left: '0px',
    right: '0px',
    top: '0px',
    position: 'fixed',
    WebkitBoxOrient: 'vertical',
    WebkitBoxDirection: 'normal',
    WebkitFlexDirection: 'column',
    msFlexDirection: 'column',
    flexDirection: 'column',
    WebkitJustifyContent: 'space-around',
    msFlexPack: 'distribute',
    justifyContent: 'space-around',
  },
  modalContainer: {
    display: 'flex',
    minHeight: '0px',
    position: 'relative',
    opacity: 1,
    borderRadius: '6px',
    margin: '0 auto',
  },
  closeButton: {
    backgroundColor: 'Transparent',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    outline: 'none',
    overflow: 'hidden',
    padding: '10px',
    position: 'fixed',
    right: '24px',
    top: '24px',
  },
};

const Modal = (props) => {
  const trackScopedAction = (action) => {
    trackRegisterAction(`unauth.account_switcher_modal.${action}`);
  };

  const handleContentClick = (event) => {
    // do not let this event propagate and close the modal
    event.stopPropagation();
  };

  const handleCloseButtonClick = () => {
    trackScopedAction('close_button_click');
    const { onCloseClick } = props;
    onCloseClick();
  };

  const handleEmptySpaceClick = () => {
    trackScopedAction('empty_space_click');
    const { onCloseClick } = props;
    onCloseClick();
  };

  const { renderContent } = props;

  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  return (
    <div style={modalStyles.mask}>
      <InlineStyle unsafeCSS={ModalCSS} />
      <div
        className="AccountSwitcherModal"
        // Clicking outside of the content in a modal usually has a different action (ie: closing the modal)
        onClick={handleEmptySpaceClick}
        role="dialog"
        style={modalStyles.scroller}
      >
        <div onClick={handleContentClick} role="dialog" style={modalStyles.modalContainer}>
          {renderContent()}
          <button
            aria-label={i18n._('close', 'accessible label for close button')}
            onClick={handleCloseButtonClick}
            style={modalStyles.closeButton}
          >
            <Icon
              accessibilityLabel={i18n._('close', 'accessible label for close button')}
              color={'white'}
              icon="cancel"
              inline
            />
          </button>
        </div>
      </div>
    </div>
  );
  /* eslint-enable jsx-a11y/click-events-have-key-events */
  /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
};

Modal.propTypes = {
  onCloseClick: PropTypes.func,
  renderContent: PropTypes.func.isRequired,
};

export default Modal;
